import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { HelpRoutes } from "ui/common/router/HelpRouter.types";
import useDestinationAddressPath from "ui/router/hooks/useDestinationAddressPath";
export interface ProtectedRouteProps {
    isAllowed: boolean;
    redirectPath?: string;
    children: ReactNode;
}

const ProtectedRoute = ({ isAllowed, redirectPath = "/", children }: ProtectedRouteProps): JSX.Element => {
    const location = useLocation();

    const destinationPath = useDestinationAddressPath(redirectPath);

    if (!isAllowed && location.pathname !== HelpRoutes.HELP) {
        return <Navigate to={destinationPath} replace />;
    }
    const fragment = <>{children}</>

    return fragment;
};

export default ProtectedRoute;
